exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-with-shadow[data-v-7faa8eaf]{box-shadow:0 4px 20px rgba(0,0,0,.05);border-radius:8px}.p-primary[data-v-7faa8eaf]{padding:1.5rem}.min-height-300[data-v-7faa8eaf]{min-height:300px}", ""]);

// exports
